import script from "./hct-table.vue?vue&type=script&setup=true&lang=js"
export * from "./hct-table.vue?vue&type=script&setup=true&lang=js"

import "./hct-table.vue?vue&type=style&index=0&id=94152a3c&scoped=true&lang=scss"

import exportComponent from "E:\\a-project\\hct-element\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94152a3c"]])

export default __exports__